import { css } from 'css-literal-loader/styled';
import PropTypes from 'prop-types';
import React from 'react';
import mapContextToProps from 'react-context-toolbox/mapContextToProps';
import { FormattedMessage } from 'react-intl';

import { AuthContext } from '../components/AuthWrapper';
import Button from '../components/Button';
import PageRoot from '../components/PageRoot';
import PageSegment from '../components/PageSegment';

const styles = require('./_invitation-expired-styles.module.scss');

const propTypes = {
  logout: PropTypes.func.isRequired,
};

class InvitationExpiredPage extends React.Component {
  componentDidMount() {
    const { logout } = this.props;

    logout();
  }

  render() {
    return (
      <PageRoot noFooter>
        <PageSegment theme="dark" align="center" grow className={styles.page}>
          <PageSegment.Heading>
            <FormattedMessage
              id="invitationExpired.heading"
              defaultMessage="Invitation expired."
            />
          </PageSegment.Heading>
          <PageSegment.Content
            display="flex"
            direction="column"
            align="center"
            pad={6}
            className={styles.body}
          >
            <FormattedMessage
              id="invitationExpired.body"
              defaultMessage="Your invitation to purchase Butterfly iQ has expired.{br}Contact us if you would like to reactivate your invitation."
              values={{ br: <br /> }}
            />
            <Button href="mailto:support@butterflynetwork.com">
              <FormattedMessage
                id="invitationExpired.contactSupport"
                defaultMessage="Contact Support"
              />
            </Button>
          </PageSegment.Content>
        </PageSegment>
      </PageRoot>
    );
  }
}

InvitationExpiredPage.propTypes = propTypes;

export default mapContextToProps(
  AuthContext,
  ({ logout }) => ({ logout }),
  InvitationExpiredPage,
);
